import * as atatus from 'atatus-spa';

const isEnabled = !!process.env.REACT_APP_ATATUS_API_KEY;
const isProduction = process.env.REACT_APP_SSO_KEY === 'prod';

const sanitizeUrl = (url) => {
  try {
    const parsed = new URL(url);
    return parsed.origin + parsed.pathname;
  } catch {
    return url?.split('?')[0] || '';
  }
};

export const initAtatus = () => {
  if (isEnabled) {
    atatus.config(process.env.REACT_APP_ATATUS_API_KEY, {
      tags: [ process.env.REACT_APP_SSO_KEY || 'local' ],
      console: !isProduction,
      reportUnhandledRejections: true,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
      ],
    }).install();
  }
};

export const notifyAtatus = (error, customData) => {
  if (isEnabled) {
    atatus.notify(error, customData ? { customData } : undefined);
  }
};

export const sanitizeApiMetadata = (error, method, url) => ({
  url: sanitizeUrl(url),
  method,
  status: error.response?.status,
});

export const setAtatusUser = (identifier) => {
  if (isEnabled) {
    const trimmed = typeof identifier === 'string' ? identifier.trim() : '';
    if (trimmed) {
      atatus.setUser(trimmed);
    }
  }
};
